module.exports = __webpack_public_path__ + "static/media/features.fd542ade.png";